import { APRICOT_FORCE_SSO_LOGIN, ETO_FORCE_SSO_LOGIN, MULTI_USER_POOLS } from 'helpers/config/environment';
import { IntegrationType } from 'helpers/integration/IntegrationType';
import { IntegrationContext } from 'helpers/integration/IntegrationContext';
import { FunctionComponent, ReactNode, useContext } from 'react';
import { FeatureFlagContext, IFeatureFlagContext } from './FeatureFlagContext';

interface IProps {
    children: ReactNode;
}

const isEnabled = (featureName: string | undefined) => {
    return featureName === 'true';
};

const fetchFeatureFlags = (type: IntegrationType): IFeatureFlagContext => {

    const featureFlags: IFeatureFlagContext = {
        forceSSOEnabled: false,
        multiUserPools: isEnabled(MULTI_USER_POOLS),
    };
    switch (type) {
        case IntegrationType.Apricot:
            featureFlags.forceSSOEnabled = isEnabled(APRICOT_FORCE_SSO_LOGIN);
            break;
        case IntegrationType.ETO:
            featureFlags.forceSSOEnabled = isEnabled(ETO_FORCE_SSO_LOGIN);
            break;
        case IntegrationType.NONE:
            featureFlags.forceSSOEnabled = true;
            break;
        default:
            break;
    }
    return featureFlags;
};

export const FeatureFlagBoundary: FunctionComponent<IProps> = ({ children }) => {
    const integration = useContext(IntegrationContext);
    const featureFlags = fetchFeatureFlags(integration.getIntegrationType());

    return (
        <FeatureFlagContext.Provider value={ featureFlags }>
            {children}
        </FeatureFlagContext.Provider>
    );
};

